import BimProduct from "../BimProduct";
import IProduct from "../../interfaces/IProduct";
import Representation3d from "../representation3d/Representation3d";
import Representation3dTypeEnum from "../representation3d/Representation3dTypeEnum";

export default class BimCovering extends BimProduct {

    
    constructor(data: IProduct, parent: BimProduct | undefined) {
        super(data, parent);
    
    }

   select3dRepresentations(representations: Representation3d[]) : Representation3d[] {


        let representation = representations.find(r => 
                                    r.representationType == Representation3dTypeEnum.TriangleMesh);

        if (!representation) {
           representation = representations.find(r => r.representationType === Representation3dTypeEnum.ExtrudedAreaSolid);
        }

        if (!representation)
            return [];

        // If the representation has a materialId, we need to create a clone without it
        // This is because we want to have textured covering and one with default material
        if (representation.materialId)
        {
            const clone = representation.clone();
            clone.materialId = null;
            return [representation, clone];
        }

        return [representation];
    };
    
};